import { type ReactElement } from "react"
import pollsAndMore from "~/images/landing/polls-and-more.png"
import pollsAndMoreLg from "~/images/landing/polls-and-more-lg@4x.png"
import { ResponsiveImage, BREAKPOINTS } from "../common/responsive-image"

export function PollsAndMoreMobileImage(): ReactElement {
  return (
    <ResponsiveImage
      sources={[
        { media: BREAKPOINTS.mobile, src: pollsAndMore },
        { media: BREAKPOINTS.tablet, src: pollsAndMore },
        { media: BREAKPOINTS.desktop, src: pollsAndMore },
      ]}
      fallbackSrc={pollsAndMore}
      alt="Polls and more"
      className="block md:hidden"
    />
  )
}

export function PollsAndMoreDesktopImage(): ReactElement {
  return (
    <ResponsiveImage
      sources={[{ media: BREAKPOINTS.desktop, src: pollsAndMoreLg }]}
      fallbackSrc={pollsAndMoreLg}
      alt="Polls and more"
      className="hidden md:block"
    />
  )
}

export function PollsAndMoreImage(): ReactElement {
  return (
    <>
      <PollsAndMoreMobileImage />
      <PollsAndMoreDesktopImage />
    </>
  )
}
